import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_venue-central-2/artifacts/9ys1e2q3_noordstraat04.png";

const links = [
  { to: "/#spaces", label: "Ruimtes" },
  { to: "/#about", label: "Het Pand" },
  { to: "/#visit", label: "Bezoek" },
  { to: "/#contact", label: "Contact" },
];

export default function Header() {
  const location = useLocation();
  const onHome = location.pathname === "/";
  const [open, setOpen] = useState(false);

  // Close the menu on route change and lock body scroll while open.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <header className="glass-header sticky top-0 z-50" data-testid="site-header">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center"
          data-testid="logo-link"
          aria-label="Noordstraat140 home"
        >
          <img
            src={LOGO_URL}
            alt="Noordstraat140"
            className="brand-mark"
            data-testid="brand-logo"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10" data-testid="primary-nav">
          {links.map((l) => (
            <a
              key={l.to}
              href={onHome ? l.to.replace("/", "") : l.to}
              className="overline hover:text-[var(--accent)] transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <NavLink
            to="/vergaderzalen"
            className="btn-ghost"
            data-testid="header-book-meeting-btn"
          >
            Boek een vergaderzaal
          </NavLink>
          <NavLink
            to="/book-desk"
            className="btn-primary"
            data-testid="header-book-desk-btn"
          >
            Boek een bureau
          </NavLink>
        </div>

        {/* Mobile: hamburger toggle */}
        <button
          type="button"
          className="md:hidden inline-flex items-center justify-center w-10 h-10 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Sluit menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </header>

    {/* Mobile drawer — rendered outside <header> to escape its backdrop-filter containing block */}
    {open && (
      <div
        className="md:hidden fixed inset-x-0 top-[64px] bottom-0 z-40 overflow-y-auto"
        style={{ backgroundColor: "var(--bg-base)" }}
        data-testid="mobile-menu-drawer"
      >
        <div className="px-6 py-8 flex flex-col gap-6">
          <nav className="flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.to}
                href={onHome ? l.to.replace("/", "") : l.to}
                onClick={() => setOpen(false)}
                className="font-serif text-2xl"
                style={{ color: "var(--text-primary)" }}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="divider mt-2" />

          <div className="flex flex-col gap-3">
            <NavLink
              to="/vergaderzalen"
              onClick={() => setOpen(false)}
              className="btn-ghost text-center"
              data-testid="mobile-header-book-meeting-btn"
            >
              Boek een vergaderzaal
            </NavLink>
            <NavLink
              to="/book-desk"
              onClick={() => setOpen(false)}
              className="btn-primary justify-center"
              data-testid="mobile-header-book-desk-btn"
            >
              Boek een bureau
            </NavLink>
          </div>

          <p
            className="overline mt-6"
            style={{ color: "var(--text-secondary)" }}
          >
            Noordstraat 140 · 8800 Roeselare
          </p>
        </div>
      </div>
    )}
    </>
  );
}
